export const accordionContent = [
  {
    title: 'Hot-desk booking',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Satus of employees',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Request management',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Hot-desk booking',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Satus of employees',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Request management',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Hot-desk booking',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Satus of employees',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
  {
    title: 'Request management',
    details:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Magni ea iure neque libero iusto quibusdam, autem',
  },
];
